import React from 'react';
import '../styles/IntroSection.css';

function IntroSection({ isMobile, isFirstPage }) {
  // 检测是否作为第一页显示（在手机端）
  const isFirstPageOnMobile = isMobile;
  
  const titleStyle = isMobile 
    ? { 
        fontSize: 'clamp(4.5rem, 18vw, 8rem)', 
        lineHeight: '0.85',
        ...(isFirstPageOnMobile && { marginTop: '80px' }) // 如果是第一页，增加顶部边距以适应Header
      }
    : {};
    
  const subtitleStyle = isMobile
    ? { fontSize: 'clamp(0.8rem, 2vw, 1.2rem)', letterSpacing: '0.15em' }
    : {};
  
  // 如果是第一页，添加额外的类
  const sectionClassName = `intro-section ${isMobile ? 'intro-section-mobile' : ''} ${isFirstPageOnMobile ? 'intro-first-page' : ''}`;
  
  return (
    <section className={sectionClassName} id="introduction">
      <div className={`intro-content ${isMobile ? 'intro-content-mobile' : ''}`}>
        <h2 
          className={`intro-title ${isMobile ? 'intro-title-mobile' : ''}`}
          style={titleStyle}
        >
          SKYRIS
        </h2>
        <h3 
          className={`intro-subtitle ${isMobile ? 'intro-subtitle-mobile' : ''}`}
          style={subtitleStyle}
        >
          THE WORLD'S FIRST FLYING PETS
        </h3>
      </div>
    </section>
  );
}

export default IntroSection; 